const ui = document.getElementById('ui')

if (!ui) {
    throw Error('No UI element found.')
}
export const UI = ui
